<h4 class="title text-hard-blue">Meu Perfil</h4>
<form [formGroup]="userForm" class="w-full">
  <mat-form-field
    class="w-full"
    appearance="outline"
  >
    <input
      matInput
      placeholder="Nome Do Usuário"
      formControlName="name"
      required
    />
    <mat-label>Nome do Usuário</mat-label>
    <mat-error *ngIf="userForm.get('name').hasError('required')">
      Informe o Nome do Usuário
    </mat-error>
  </mat-form-field>

  <mat-form-field
    class="w-full"
    appearance="outline"
  >
    <input
      matInput
      placeholder="Email Do Usuário"
      formControlName="email"
      required
    />
    <mat-label>Email do Usuário</mat-label>
    <mat-error *ngIf="userForm.get('email').hasError('required')">
      Informe o Email do Usuário
    </mat-error>
  </mat-form-field>

  <mat-form-field
    class="w-full"
    appearance="outline"
  >
    <input
      matInput
      mask="(00) 0000-0000||(00) 00000-0000"
      placeholder="Telefone Do Usuário"
      formControlName="mobile"
      required
    />
    <mat-label>Telefone do Usuário</mat-label>
    <mat-error *ngIf="userForm.get('mobile').hasError('required')">
      Informe o Telefone do Usuário
    </mat-error>
  </mat-form-field>

  <div align="end">
    <button
      mat-raised-button
      color="primary"
      (click)="onSubmit()"
    >
      Salvar Usuário
    </button>
  </div>
</form>
